export class PolicyInfo {
    policyNumber?: string;
    productType?: string;
    nickName?: string;
    companyName?: string; 
    isActive?: boolean; 
    policyHoldersName?: string;
}